import { useMemo, useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import _ from 'lodash';

export const ALL_OPTION = '__all__';

export const parseArrayParam = (params, key) =>
  _.filter(params.getAll(key), Boolean);

export const parseStringParam = (params, key) => params.get(key) || undefined;

export const singleToArray = (v) => (v && v !== ALL_OPTION ? [String(v)] : []);
export const arrayToSingle = (arr) => (_.isEmpty(arr) ? ALL_OPTION : arr[0]);

const pairsFromArrays = (entries) =>
  _.flatMap(entries, ([key, arr]) => _.map(arr || [], (v) => [key, v]));

const pairsFromScalars = (entries) =>
  _.filter(entries, ([, v]) => Boolean(v));

export const buildQueryString = (arrayFields, scalarFields) => {
  const pairs = [...pairsFromArrays(arrayFields), ...pairsFromScalars(scalarFields)];
  return _.reduce(pairs, (acc, [k, v]) => { acc.append(k, v); return acc; }, new URLSearchParams()).toString();
};

export const useUrlState = (parse, build) => {
  const history = useHistory();
  const location = useLocation();
  const state = useMemo(() => parse(location.search), [location.search, parse]);
  const setState = useCallback((updates) => {
    const next = { ...state, ...updates };
    history.replace(`${location.pathname}?${build(next)}`);
  }, [state, history, location.pathname, build]);
  return { state, setState };
};
